var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSociety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 323,
    viewBox: "0 0 400 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.0039 123.977L55.2723 18.7134L46.0039 15.5945L45.5583 21.0526L36.6472 130.214L307.992 175.439V169.277L46.0039 123.977Z",
    fill: "#9AD6D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M307.992 175.439L36.6472 130.214L29.6296 134.113L0 154.386L18.7134 156.725H22.6121L17.154 162.963H23.3918L29.6296 157.505L79.5322 165.302V170.76H84.2105L94.347 167.641L138.791 172.32V178.557L145.029 175.439L240.156 186.355V191.033L254.191 187.914L275.244 191.033V194.152L329.045 184.795V181.676L331.384 182.456V179.337L307.992 175.439Z",
    fill: "#67D6D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6472 130.214L45.5583 21.0526L38.9864 18.7134L29.6296 134.113L36.6472 130.214Z",
    fill: "#67D6D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.45 75.6335L58.4796 0L56.8319 18.7134L47.5635 123.977L309.552 169.277L318.129 170.76L313.45 75.6335Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M185.537 56.615L190.579 60.4773C191.885 61.4777 193.671 61.5764 195.079 60.726L201.545 56.8221C203.843 55.4346 206.829 56.6599 207.489 59.2618L209.473 67.0722C209.911 68.797 211.436 70.025 213.214 70.0853L219.149 70.2865C222.002 70.3832 223.839 73.3525 222.651 75.9487L219.744 82.3C218.921 84.0977 219.535 86.2269 221.189 87.3103L226.816 90.9972C229.474 92.7385 229.139 96.7341 226.228 98.0076L220.286 100.607C218.331 101.462 217.391 103.702 218.151 105.696L220.578 112.067C221.634 114.838 219.413 117.754 216.461 117.473L209.94 116.852C208.155 116.682 206.475 117.721 205.829 119.394L203.275 126.011C202.314 128.501 199.23 129.37 197.111 127.747L191.546 123.484C190.276 122.511 188.55 122.388 187.155 123.171L179.372 127.541C177.141 128.793 174.323 127.657 173.584 125.207L170.39 114.607C169.844 112.797 168.106 111.616 166.222 111.775L161.984 112.135C158.797 112.405 156.597 109.01 158.147 106.212L160.71 101.58C161.664 99.8583 161.223 97.6991 159.671 96.4888L154.445 92.4122C152.192 90.6555 152.454 87.1723 154.944 85.7719L162.792 81.3571C164.567 80.3586 165.309 78.1856 164.514 76.3102L162.09 70.5882C160.933 67.8596 163.042 64.865 166.001 65.0341L174.089 65.4963C175.965 65.6035 177.663 64.3907 178.169 62.5813L179.253 58.712C180.016 55.9868 183.29 54.8941 185.537 56.615Z",
    stroke: "#3D3D3D",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M167.402 70.3303L167.962 68.3699C169.1 64.3855 173.048 61.8902 177.135 62.5715C179.342 62.9393 181.604 62.3833 183.389 61.0337L184.959 59.8465C188.482 57.1823 193.376 57.2913 196.777 60.1097L197.093 60.3716C198.847 61.8242 201.107 62.5164 203.373 62.2943L205.323 62.1032C209.299 61.7134 212.744 64.8374 212.744 68.8324C212.744 71.128 213.909 73.2668 215.837 74.5122L219.022 76.5694C222.239 78.6471 223.107 82.9701 220.942 86.1285C219.621 88.0546 219.381 90.5238 220.306 92.6683L221.221 94.7904C223.008 98.9326 221.248 103.779 217.252 105.872C215.052 107.025 213.445 109.103 212.907 111.528L212.627 112.787C211.834 116.354 208.442 118.72 204.821 118.23C202.928 117.974 201.012 118.5 199.514 119.685L195.302 123.02C192.181 125.49 187.664 125.043 185.089 122.008C183.539 120.181 181.2 119.22 178.813 119.429L176.373 119.643C171.775 120.047 167.658 116.8 166.978 112.234C166.619 109.83 165.275 107.684 163.267 106.313L162.822 106.008C158.882 103.318 157.402 98.2115 159.294 93.8314L159.346 93.7103C160.311 91.4755 160.403 88.96 159.603 86.6609L159.151 85.36C157.804 81.4881 159.54 77.2183 163.207 75.385C165.252 74.3625 166.773 72.5287 167.402 70.3303Z",
    stroke: "#E64C4C",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.148 60.9187L186.253 62.3202C187.341 62.6917 188.523 62.6769 189.602 62.2784L196.133 59.8648C198.184 59.1069 200.489 59.7695 201.825 61.5008L205.057 65.6907C205.922 66.8115 207.221 67.5133 208.632 67.6219L211.672 67.8557C214.277 68.0561 216.288 70.2283 216.288 72.841V77.4368C216.288 78.8188 216.86 80.1392 217.869 81.0845L221.421 84.4147C223.15 86.0356 223.503 88.6475 222.268 90.6697L219.82 94.675C219.176 95.7285 218.945 96.983 219.171 98.1968L220.087 103.12C220.527 105.484 219.221 107.827 216.979 108.696L210.633 111.157C209.244 111.696 208.168 112.825 207.697 114.238L207.082 116.083C206.271 118.514 203.755 119.939 201.254 119.383L195.946 118.204C194.856 117.961 193.716 118.091 192.708 118.572L186.836 121.375C184.68 122.404 182.096 121.763 180.67 119.846L176.915 114.795C176.186 113.814 175.123 113.135 173.927 112.884L168.873 111.827C166.557 111.342 164.897 109.299 164.897 106.933V100.547C164.897 99.4423 164.531 98.3684 163.856 97.4934L160.295 92.8769C158.965 91.153 158.904 88.7669 160.143 86.9768L163.681 81.8664C164.458 80.7441 164.742 79.3529 164.468 78.0157L163.845 74.9779C163.302 72.3346 164.955 69.7379 167.58 69.1103L171.932 68.0696C173.548 67.6831 174.867 66.5185 175.451 64.9623L175.851 63.8948C176.8 61.3634 179.59 60.0451 182.148 60.9187Z",
    stroke: "#9AD6D6",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.238 89.4767C191.488 89.0265 190.114 90.8008 189.12 92.3202C188.875 92.6955 189.316 93.0586 189.651 92.7606L192.713 90.0394C193.057 89.7328 193.562 90.1572 193.318 90.5493L191.578 93.3535C191.337 93.742 191.831 94.1658 192.178 93.8682L195.797 90.7658C196.129 90.4818 196.611 90.8581 196.415 91.2484L195.271 93.5362C195.064 93.9504 195.609 94.3267 195.923 93.9864L197.94 91.8019C198.258 91.4565 198.809 91.8489 198.586 92.2629L197.457 94.3589C197.251 94.7411 197.716 95.1315 198.057 94.8625L199.887 93.4177C200.225 93.1506 200.689 93.5341 200.49 93.9165L197.041 100.537C196.817 100.969 197.412 101.352 197.712 100.968L203.124 94.0336L196.636 104.548C196.417 104.904 196.813 105.301 197.161 105.068C200.027 103.15 201.944 100.917 204.896 95.0462",
    stroke: "#FFB200",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M175.024 93.7799C175.409 92.9119 175.963 92.4618 176.858 91.9147C177.036 91.8057 177.236 92.0116 177.126 92.1887L175.612 94.6106C175.494 94.7997 175.727 95.0111 175.904 94.8752L177.58 93.5854C177.751 93.4542 177.98 93.6481 177.879 93.838L176.804 95.8535C176.699 96.0496 176.945 96.2445 177.112 96.0981L179.255 94.2233C179.429 94.0704 179.681 94.2881 179.554 94.4828L177.521 97.6108C177.405 97.7886 177.61 98.0004 177.791 97.8912L178.705 97.3431C178.893 97.2302 179.1 97.459 178.968 97.6346L177.667 99.3695C177.551 99.5239 177.699 99.7365 177.884 99.681L179.074 99.3242C179.273 99.2644 179.42 99.5102 179.273 99.6571L178.869 100.061C178.721 100.209 178.895 100.452 179.083 100.358V100.358C179.242 100.278 179.412 100.447 179.332 100.606L178.947 101.376C178.852 101.565 179.077 101.752 179.246 101.626L180.194 100.915C180.338 100.806 180.541 100.93 180.511 101.108L180.379 101.901C180.358 102.023 180.453 102.134 180.576 102.134H180.699C180.864 102.134 180.958 102.322 180.859 102.454L180.58 102.827C180.481 102.959 180.575 103.147 180.74 103.147H181.45C181.541 103.147 181.621 103.208 181.64 103.298C181.735 103.739 181.938 104.911 181.099 103.653",
    stroke: "#FFB200",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.998 85.9327L192.745 85.6796L191.985 84.6669L193.504 85.1733L192.998 83.4777L194.287 84.821C194.434 84.9746 194.688 84.8222 194.621 84.62L194.056 82.9019C193.988 82.6961 194.25 82.5445 194.395 82.7059L194.629 82.9668C194.762 83.1158 195.007 82.9982 194.975 82.8009L194.635 80.7371C194.602 80.5363 194.855 80.4202 194.986 80.5762L196.246 82.0802C196.382 82.2423 196.643 82.1102 196.594 81.9046L195.917 79.1132C195.864 78.8967 196.152 78.7695 196.277 78.9539L197.677 81.0208C197.808 81.2136 198.107 81.0653 198.032 80.8446L197.033 77.8865C196.956 77.6587 197.272 77.5138 197.394 77.721L201.397 84.5128C201.522 84.7251 201.845 84.5674 201.755 84.338L199.622 78.9149C199.532 78.6856 199.856 78.5279 199.981 78.7403L202.284 82.6528C202.403 82.8545 202.712 82.723 202.649 82.4975L201.969 80.0639C201.906 79.8374 202.218 79.7065 202.335 79.9103L204.002 82.8038C204.098 82.9716 204.355 82.8947 204.344 82.7014V82.7014C204.331 82.4747 204.66 82.4304 204.707 82.6525L205.402 85.9327V80.8696L206.415 84.9201L206.162 81.8822L207.681 84.6669",
    stroke: "#FFB200",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 191.226,
    cy: 89.7294,
    r: 25.0658,
    stroke: "#FFB200",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.96 80.3625H188.947V80.3625C188.724 80.3625 188.587 80.1194 188.701 79.9283L190.715 76.5727C190.883 76.292 190.545 75.9829 190.28 76.1762L182.696 81.7258C182.352 81.9773 181.913 81.5718 182.136 81.2092V81.2092C182.357 80.8499 181.927 80.4456 181.582 80.6883L178.184 83.0794C177.984 83.2202 177.755 82.9474 177.928 82.7745L184.39 76.3119L177.302 82.3877L182.871 76.3119L177.982 79.979C177.72 80.1754 177.378 79.8705 177.543 79.5879L178.568 77.8309",
    stroke: "#FFB200",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M332.977 64.5436C332.977 64.5436 329.383 62.7685 327.655 61.8214C326.471 61.174 325.848 61.5074 326.086 61.9928C326.202 62.2307 326.453 62.3322 327.035 62.6922C327.615 63.049 328.514 63.5726 328.514 63.5726C328.514 63.5726 328.598 65.3812 328.526 66.381C328.453 67.3808 329.614 67.2916 330.262 67.4577C330.906 67.6222 332.395 67.7457 333.415 67.5054C334.426 67.2649 334.483 65.655 332.977 64.5436Z",
    fill: "#FFD4C4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.746 82.5011C321.517 83.7131 319.206 85.4269 317.301 84.7661C315.396 84.1053 315.071 82.5682 315.227 80.6565C315.382 78.7518 316.255 79.6741 316.481 80.1441C316.774 80.7554 316.654 81.4586 316.654 81.4586C316.654 81.4586 318.124 80.6282 319.096 80.501C320.372 80.3314 322.004 81.13 321.746 82.5011Z",
    fill: "#FFEBE3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.892 43.4722C329.892 43.4722 329.213 45.8681 329.467 47.7268C329.722 49.589 329.892 53.2958 331.542 54.4831C333.192 55.6704 335.563 54.2923 337.128 52.9636C338.694 51.635 340.358 49.1826 340.397 46.2144C340.436 43.2496 339.273 39.6135 334.991 39.7972C330.708 39.9845 329.892 43.4722 329.892 43.4722Z",
    fill: "#FFEBE3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.374 52.0469C338.374 52.0469 338.042 55.8668 339.042 57.2767C339.116 58.2166 336.416 62.1991 333.734 61.503C332.172 61.1001 332.36 59.2767 332.36 59.2767C332.529 57.888 332.36 54.5275 332.36 54.5275L338.374 52.0469Z",
    fill: "#FFEBE3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.116 58.4199C337.134 58.533 337.826 59.3139 337.826 59.3139C337.826 59.3139 336.448 62.3282 335.946 63.6568C335.448 64.989 334.141 66.0986 334.141 66.0986L332.353 64.148C334.819 62.8511 337.116 58.4199 337.116 58.4199Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.226 55.9771C332.389 55.7757 332.781 59.7405 333.375 60.744C332.23 61.8218 331.544 62.1116 331.544 62.1116C331.544 62.1116 330.866 57.6698 332.226 55.9771Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.353 54.0611C333.508 54.5028 335.197 53.8102 337.392 52.0469C337.392 52.0469 336.741 54.6194 332.353 55.5629V54.0611Z",
    fill: "#FFD5C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.136 38.7527C328.525 40.9506 329.221 41.7422 331.076 42.3747C332.935 43.0037 337.871 41.5761 337.871 41.5761C337.539 43.9295 338.281 45.1521 338.281 45.1521C339.098 42.8376 339.84 44.0143 339.914 45.8659C339.988 47.7176 338.946 47.6752 338.946 47.6752C339.02 49.2335 339.522 49.7636 339.522 49.7636C341.508 48.3925 344.211 39.2262 340.635 39.0142C340.585 35.8091 330.444 34.0423 329.136 38.7527Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M325.926 134.113C325.926 134.113 326.46 103.322 325.926 94.3467C325.391 85.371 335.283 96.686 344.639 93.5676L343.08 116.179L344.639 134.893L337.622 136.452L335.283 105.263L332.944 134.893L325.926 134.113Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0227 112.28L84.2103 179.337H74.8536L68.6158 139.571L65.4969 179.337L56.1401 177.502L57.6996 145.809V115.399L79.0227 112.28Z",
    fill: "black",
    stroke: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6026 174.698L65.0159 175.399C65.3199 175.424 65.5957 175.587 65.7649 175.841L66.0201 176.223C66.4631 176.888 65.9868 177.778 65.1881 177.778H55.4357C54.5448 177.778 54.0986 176.701 54.7286 176.071L55.8124 174.987C56.0204 174.779 56.3095 174.673 56.6026 174.698Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6551 174.857L83.4924 173.247C83.9628 173.161 84.428 173.421 84.6026 173.866L85.2753 175.581C85.521 176.208 85.0902 176.893 84.4191 176.944L74.6907 177.673C74.0063 177.725 73.4748 177.087 73.6484 176.423L73.8668 175.588C73.9652 175.211 74.2726 174.926 74.6551 174.857Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1879 88.0348C62.1879 88.0348 58.6766 93.0827 59.705 97.3096C60.7333 101.536 58.876 101.568 57.8437 105.795C56.8076 110.021 55.0871 113.29 57.007 116.942C58.9268 120.594 62.8409 123.539 68.9485 120.016C71.8381 118.35 83.3768 113.267 81.7502 109.849C79.9672 106.096 78.7522 105.795 79.6075 102.139C80.3117 88.0348 79.6075 91.3042 79.6075 86.5506C77.9496 82.1282 79.5717 82.6527 77.9725 82.6527C76.3733 82.6527 79.9516 80.6681 73.1245 81.4384C68.6318 81.9389 62.1879 88.0348 62.1879 88.0348Z",
    fill: "#1C2828"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8755 79.807C73.8755 79.807 74.2704 87.291 73.8755 88.4758C73.4806 89.6566 70.6536 88.7495 68.7767 86.2001C66.8998 83.6429 67.5724 83.6038 68.0611 82.9821C69.59 81.0427 68.8862 76.9097 68.8862 75.111C68.8862 73.3045 73.8755 79.807 73.8755 79.807Z",
    fill: "#6F4F21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1827 65.0474C71.4798 65.0631 76.5982 65.7747 78.2404 68.6486C79.8827 71.5226 79.0694 83.2412 75.5464 83.2412C73.9549 83.2412 67.3859 79.3741 65.6381 76.4141C63.8864 73.4542 62.3145 64.5821 71.1827 65.0474Z",
    fill: "#8B6226"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M326.276 130.995H332.511C332.776 130.995 333.018 131.144 333.137 131.382L333.996 133.1C334.229 133.566 333.891 134.114 333.37 134.114H324.987C324.41 134.114 324.081 133.455 324.427 132.994L325.716 131.275C325.848 131.098 326.056 130.995 326.276 130.995Z",
    fill: "#333333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M337.929 133.192L338.242 132.253C338.337 131.967 338.605 131.774 338.906 131.774H344.135C344.436 131.774 344.704 131.967 344.799 132.253L345.112 133.192C345.263 133.645 344.926 134.114 344.448 134.114H338.593C338.115 134.114 337.778 133.645 337.929 133.192Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M326.276 130.995H332.511C332.776 130.995 333.018 131.144 333.137 131.382L333.996 133.1C334.229 133.566 333.891 134.114 333.37 134.114H324.987C324.41 134.114 324.081 133.455 324.427 132.994L325.716 131.275C325.848 131.098 326.056 130.995 326.276 130.995Z",
    stroke: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M337.929 133.192L338.242 132.253C338.337 131.967 338.605 131.774 338.906 131.774H344.135C344.436 131.774 344.704 131.967 344.799 132.253L345.112 133.192C345.263 133.645 344.926 134.114 344.448 134.114H338.593C338.115 134.114 337.778 133.645 337.929 133.192Z",
    stroke: "#333333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9538 112.262L68.1331 113.957C68.1331 113.957 71.4857 114.61 72.6757 116.188C73.4604 117.228 73.8013 119.329 73.8013 119.329L74.0082 120.907C74.0082 120.907 72.8288 120.695 72.7536 120.121C72.6784 119.547 71.6312 117.275 71.6312 117.275L70.3694 116.163L71.3231 117.572C71.3231 117.572 71.5973 119.784 71.9372 120.181C72.2844 120.573 72.676 122.056 72.2456 122.112C71.1678 122.254 70.7554 120.762 70.9931 121.342C71.7181 123.112 69.7617 121.996 69.7617 121.996L68.4014 119.982L67.8061 121.578C67.8061 121.578 67.7379 122.171 67.0469 121.382C66.3598 120.593 66.5833 118.958 66.5833 118.958C66.5833 118.958 65.9669 117.141 65.4426 116.48C64.9177 115.815 63.3322 115.697 63.3322 115.697C63.3322 115.697 63.5033 111.798 65.9538 112.262Z",
    fill: "#8B6226"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5131 74.6134C67.5131 74.6134 65.4877 73.3817 64.8973 75.4658C64.3068 77.5499 67.3411 78.5 67.3411 78.5L67.5131 74.6134Z",
    fill: "#F3C37C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4774 86.9469C65.4774 86.9469 68.4178 86.9547 67.9799 92.6518C67.538 98.3449 63.7882 105.516 63.7882 107.158C63.7882 108.801 68.496 114.071 68.496 114.071C68.496 114.071 66.7717 114.76 66.4197 115.882C66.0678 117.004 65.626 117.461 65.626 117.461C65.626 117.461 53.5633 113.633 56.7226 103.526C59.8898 93.426 61.9466 85.2186 65.4774 86.9469Z",
    fill: "#8B6226"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1683 226.27L36.6473 322.807H48.3432L68.6676 245.744L63.1683 226.27Z",
    fill: "#F8D47A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4041 223.992L68.8912 205.439L64.084 222.937L69.6117 242.164L74.4041 223.992Z",
    fill: "#F8D47A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7701 180.897H75.6336L68.8912 205.439L74.4041 223.992L80.4234 201.17L85.1531 183.236L85.7701 180.897Z",
    fill: "#F8D47A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4234 201.17L115.4 320.468H127.096L85.1531 183.236L80.4234 201.17Z",
    fill: "#F8D47A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5985 180.897H53.0215L14.0352 321.247H23.3919L56.0798 201.17L56.9288 198.051L61.5985 180.897Z",
    fill: "#F8D47A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4485 317.349H92.7877L71.1713 242.164L70.2271 245.744L90.4485 317.349Z",
    fill: "url(#paint0_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7279 226.27L70.2271 245.744L71.1713 242.164L65.6435 222.937L64.7279 226.27Z",
    fill: "url(#paint1_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5422 222.072L64.4473 218.777L58.4884 198.051L57.6394 201.17L63.5422 222.072Z",
    fill: "url(#paint2_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4622 180.897L12.4758 321.247H15.5947L54.5811 180.897H51.4622Z",
    fill: "url(#paint3_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8676 322.807H38.2068L64.7279 226.27L63.5422 222.072L35.8676 322.807Z",
    fill: "url(#paint4_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6435 222.937L70.4507 205.439L69.2353 201.349L64.4473 218.777L65.6435 222.937Z",
    fill: "url(#paint5_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1932 180.897H74.854L69.2353 201.349L70.4507 205.439L77.1932 180.897Z",
    fill: "url(#paint6_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2945 176.998V180.897H88.1094V176.218H73.2945V176.998Z",
    fill: "url(#paint7_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M116.959 321.247L81.9829 201.17L80.8411 205.499L113.84 321.247H116.959Z",
    fill: "url(#paint8_linear)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7279 226.27L65.6435 222.937L64.4473 218.777L63.5422 222.072L64.7279 226.27Z",
    fill: "url(#paint9_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9027 176.218V180.897H73.2945V176.998V176.218H49.9027Z",
    fill: "#EAC15D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9637 223.992L70.4507 205.439L65.6435 222.937L71.1713 242.164L75.9637 223.992Z",
    fill: "#EAC15D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1581 180.897L58.4884 198.051L64.4473 218.777L69.2353 201.349L63.1581 180.897Z",
    fill: "#EAC15D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7877 317.349H103.704L75.9637 223.992L71.1713 242.164L92.7877 317.349Z",
    fill: "#EAC15D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8711 208.187H49.9023L47.5631 210.526H82.9023L81.8711 208.187Z",
    fill: "#F7B827"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0364 239.376H40.6517L39.7659 242.495H58.0259L59.0364 239.376Z",
    fill: "#F7B827"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0739 240.156H91.2279L92.0076 243.275H74.0739V240.156Z",
    fill: "#F7B827"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7483 271.345H50.1419L49.4749 273.684H31.9686L32.7483 271.345Z",
    fill: "#F7B827"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8048 271.345H83.4306L84.2103 274.464H100.585L99.8048 271.345Z",
    fill: "#F7B827"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6906 302.534H24.1713L23.3916 305.653H40.8436L41.6906 302.534Z",
    fill: "#F7B827"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.162 302.534H92.0076V306.433H109.941L109.162 302.534Z",
    fill: "#F7B827"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M330.107 139.936H320.955L279.352 314.628H289.336L324.218 165.17L325.124 161.288L330.107 139.936Z",
    fill: "#EAC15D"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M331.782 196.412L303.481 316.569H315.962L337.651 220.65L331.782 196.412Z",
    fill: "#EAC15D"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M343.772 193.577L337.889 170.484L332.759 192.264L338.658 216.194L343.772 193.577Z",
    fill: "#EAC15D"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M355.901 139.936H345.084L337.889 170.484L343.772 193.577L350.195 165.17L355.243 142.848L355.901 139.936Z",
    fill: "#EAC15D"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M350.195 165.17L387.519 313.658H400L355.243 142.848L350.195 165.17Z",
    fill: "#EAC15D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M340.924 135.084V139.936H356.733V134.113H340.924V135.084Z",
    fill: "#EAC15D"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M317.626 139.936L276.023 314.628H279.352L320.955 139.936H317.626Z",
    fill: "#F7B827"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M330.517 191.186L331.483 187.085L325.124 161.288L324.218 165.17L330.517 191.186Z",
    fill: "#F7B827"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M331.782 196.412L337.651 220.65L338.658 216.194L332.759 192.264L331.782 196.412Z",
    fill: "#F7B827"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M331.782 196.412L332.759 192.264L331.483 187.085L330.517 191.186L331.782 196.412Z",
    fill: "#F7B827"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M359.229 309.776H361.725L338.658 216.194L337.651 220.65L359.229 309.776Z",
    fill: "#F7B827"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M300.985 316.569H303.481L331.782 196.412L330.517 191.186L300.985 316.569Z",
    fill: "#F7B827"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M332.759 192.264L337.889 170.484L336.592 165.393L331.483 187.085L332.759 192.264Z",
    fill: "#F7B827"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M345.084 139.936H342.588L336.592 165.393L337.889 170.484L345.084 139.936Z",
    fill: "#F7B827"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M387.519 313.658L350.195 165.17L348.931 170.76L384.191 314.628L387.519 313.658Z",
    fill: "#F7B827"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M400 313.658H387.519L384.191 314.628H400V313.658Z",
    fill: "#F7B827"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M315.962 134.113V139.936H340.924V135.084V134.113H315.962Z",
    fill: "#F7B827"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M331.483 187.085L336.592 165.393L330.107 139.936L325.124 161.288L331.483 187.085Z",
    fill: "#F8D47A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M343.772 193.577L337.889 170.484L332.759 192.264L338.658 216.194L343.772 193.577Z",
    fill: "#F8D47A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M361.725 309.776H373.374L343.772 193.577L338.658 216.194L361.725 309.776Z",
    fill: "#F8D47A"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M350.078 173.903H315.964L313.468 176.815H350.877L350.078 173.903Z",
    fill: "#F7B827"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M326.706 212.865H306.433L305.147 216.606H325.926L326.706 212.865Z",
    fill: "#F7B827"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M341.758 213.694H359.231L360.063 217.576H341.758V213.694Z",
    fill: "#F7B827"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M297.659 252.515L316.569 252.631L316.08 255.426H296.826L297.659 252.515Z",
    fill: "#F7B827"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M369.591 252.631L351.742 252.515L352.574 256.397H370.371L369.591 252.631Z",
    fill: "#F7B827"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M307.213 291.335H288.499L287.674 295.217H306.433L307.213 291.335Z",
    fill: "#F7B827"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M379.463 291.618H359.454L360.895 296.188H380.507L379.463 291.618Z",
    fill: "#F7B827"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M283.821 90.4482L296.663 70.1753L314.398 75.0899L315.01 83.6906L283.821 90.4482Z",
    fill: "#E3DFDF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.739 316.569H212.086L209.747 183.236L191.033 180.897L190.739 316.569Z",
    fill: "#3D3D3D"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M177.778 179.337V316.569H190.739L191.033 180.897L177.778 179.337Z",
    fill: "#231F20"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7532 72.5146C78.7532 72.5146 78.579 69.8948 77.193 69.3957C75.8071 68.8966 69.966 64.9176 70.1756 64.7178C70.3851 64.518 71.5552 64.276 73.8725 63.9621C76.1938 63.6522 80.3116 68.6157 78.7532 72.5146Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5983 97.4658C63.3284 99.3048 71.1381 88.9715 71.8237 88.8843C72.5123 88.7999 69.5597 83.8902 69.1745 81.1874C68.7894 78.4847 69.1541 73.8257 70.184 70.6924C71.214 67.5592 73.2942 66.6955 73.2942 66.6955C73.2942 66.6955 70.2482 62.8702 67.85 64.2297C65.4517 65.5893 64.343 66.7827 63.9375 72.259",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.808 55.9803C331.9 55.8001 341.38 57.9238 344.504 61.9027C347.624 65.8816 343.094 72.9101 342.009 77.147C340.925 81.3838 345.419 94.1054 345.419 95.1266C340.575 98.3352 325.991 96.6563 324.68 91.8682C324.136 86.6596 325.334 80.4721 325.398 77.4261C325.239 70.8818 322.394 57.9168 327.808 55.9803Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M342.615 61.0007C338.81 62.8948 335.785 73.3792 332.88 76.1884C331.234 77.7856 323.11 79.8634 320.852 79.9164C319.975 81.9059 321.551 84.118 321.551 84.118C335.421 82.8176 337.17 80.708 341.432 75.2697C346.732 68.5274 347.715 59.7003 342.615 61.0007Z",
    fill: "#E64C4C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.898 55.9697C323.294 57.263 320.817 68.8252 319.53 71.426C318.241 74.0232 307.488 74.6699 307.488 74.6699C306.841 76.9208 308.671 79.2848 308.671 79.2848C319.029 78.8537 322.679 77.995 324.601 73.9137C326.516 69.8323 333.259 57.362 327.898 55.9697Z",
    fill: "#E64C4C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M307.162 74.5742C307.162 74.5742 304.819 74.3115 304.108 74.789C303.397 75.2665 301.115 76.4427 300.625 76.2004C300.134 75.9581 298.503 76.0731 299.346 76.8207C300.189 77.5684 301.774 77.4222 301.774 77.4222L303.044 77.5084L301.942 79.1665C301.942 79.1665 300.746 80.1239 300.262 80.2907C299.833 80.4363 298.887 81.1248 298.479 81.3944C298.071 81.664 297.551 81.7734 297.265 82.3519C297.146 82.5938 297.68 82.766 297.68 82.766L302.167 80.6727C302.167 80.6727 303.111 82.0983 304.637 82.1885C306.16 82.2822 309.807 76.9791 309.807 76.9791L307.162 74.5742Z",
    fill: "#FFEBE3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6486 81.0918C76.6486 81.0918 83.159 81.2326 84.246 83.7311C85.333 86.2297 93.1141 89.4399 93.685 89.4399C94.2559 89.4399 107.187 88.0635 107.187 88.0635C107.187 88.0635 109.834 89.6784 108.903 91.8642C107.973 94.0538 94.2481 97.7763 91.03 95.919C87.8081 94.0656 74.4902 90.957 76.6486 81.0918Z",
    fill: "#8B6226"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M103.341 89.8912C103.341 89.8912 104.143 87.6741 104.886 87.2479C105.629 86.8217 107.693 85.2968 107.693 84.7494C107.693 84.202 108.518 82.7904 108.815 83.8774C109.113 84.9644 108.28 86.3212 108.28 86.3212L107.795 87.4982L109.77 87.244C109.77 87.244 111.158 86.595 111.521 86.2352C111.842 85.9146 112.878 85.3711 113.3 85.1247C113.723 84.8784 114.051 84.46 114.696 84.46C114.966 84.46 114.884 85.0153 114.884 85.0153L111.021 88.1121C111.021 88.1121 111.881 89.5901 111.287 90.9978C110.696 92.4054 104.327 93.3282 104.327 93.3282L103.341 89.8912Z",
    fill: "#8B6226"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 70.9554,
    y1: 176.218,
    x2: 4.67857,
    y2: 320.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7C474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociety);
export default __webpack_public_path__ + "static/media/society.896df1fe0b8cf0854a1998867d35db98.svg";
export { ForwardRef as ReactComponent };